import Select from "react-select";
import { useContext, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useSelector } from "react-redux";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import ItemInfo from "../../../utils/ItemInfo/ItemInfo";
import { categoryAdminContext } from "../../../context/Admin/CategoryAdminContext/CategoryAdminContext";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";
import { displayModeItems, displayModeToText } from "../../../utils";

const CategoryAdmin = () => {
  const appConfigs = useSelector((state) => state.appConfigs);
  const permission = useSelector((state) => state.permission);
  const cities = useSelector((state) => state.cities);

  const [displayMode, setDisplayMode] = useState(displayModeItems[1]);

  const {
    categoryItems,
    category,
    added_cities,
    setAdded_cities,
    id,
    icon,
    setIcon,
    description,
    setDescription,
    name,
    setName,
    smallIcon,
    setSmallIcon,
    rank,
    setRank,
    search,
    setSearch,
    isShowModal,
    isShowDetailsModal,
    handleShowDetailsModal,
    handleCloseDetailsModal,
    handleShowModal,
    handleCloseModal,
    handleGetCategoryItemList,
    handleGetCategoryItem,
    handleCreateCategoryItem,
    handleEditCategoryItem,
    handleDeleteCategoryItem,
  } = useContext(categoryAdminContext);

  useEffect(() => {
    handleGetCategoryItemList();
  }, []);

  return (
    <>
      <SiteTitle title="دسته بندی" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "دسته بندی", type: "a" },
        ]}
        title="آیتم های دسته بندی"
      />

      <CardLayout>
        {permission.service_category_create_update && (
          <div className="mb-2">
            <button
              className="btn btn-success"
              onClick={() => handleShowModal()}
            >
              <i className="fa fa-plus mr-2" />
              افزودن
            </button>
          </div>
        )}
        <div>
          <form onSubmit={handleGetCategoryItemList}>
            <div className="input-group mb-3">
              <input
                type="text"
                name="search"
                autoComplete="off"
                placeholder="جستجو ..."
                className="form-control"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <div className="input-group-append">
                <button type="submit" className="btn btn-primary">
                  جستجو
                </button>
              </div>
            </div>
          </form>
          <div className="d-flex align-items-center justify-content-end my-2">
            <span>نحوه نمایش:</span>
            <div>
              {displayModeItems.map((item) => (
                <button
                  key={item}
                  className={`ml-2 btn btn-${
                    displayMode === item ? "info" : "white border"
                  }`}
                  onClick={() => setDisplayMode(item)}
                >
                  {displayModeToText(item)}
                </button>
              ))}
            </div>
          </div>
        </div>
        {isEmpty(categoryItems) ? (
          <EmptyData />
        ) : (
          <>
            {displayMode === displayModeItems[0] ? (
              <Table responsive hover borderless striped>
                <thead className="thead-dark">
                  <tr>
                    <th>#</th>
                    <th>شناسه</th>
                    <th>نام</th>
                    <th>توضیحات</th>
                    <th>آیکن</th>
                    <th>آیکن گرد</th>
                    <th>جایگاه</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {categoryItems.map((_item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{_item.id}</td>
                      <td>{_item.name}</td>
                      <td>{_item.description}</td>
                      <td>{_item.icon}</td>
                      <td>{_item.small_icon}</td>
                      <td>{_item.rank}</td>
                      <td className="mw-25">
                        {/* <button
                          onClick={() =>
                            handleGetCategoryItem(
                              _item.id,
                              handleShowDetailsModal
                            )
                          }
                          className="btn btn-info mr-2"
                        >
                          جزئیات
                        </button> */}
                        {permission.service_category_create_update && (
                          <button
                            onClick={() => handleShowModal(_item)}
                            className="btn btn-primary mr-2"
                          >
                            جزئیات و ویرایش
                          </button>
                        )}
                        {permission.service_category_delete && (
                          <i
                            onClick={() =>
                              areYouSureMessage(
                                () => handleDeleteCategoryItem(_item.id),
                                `آیا از حذف ${_item.name} اطمینان دارید؟`
                              )
                            }
                            className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                          />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : displayMode === displayModeItems[1] ? (
              <div className="row justify-content-center mx-0">
                {categoryItems?.map((_item, index) => (
                  <div className="col-auto my-2 px-1" key={index}>
                    <span
                      className="cursorPointer"
                      onClick={() => handleShowModal(_item)}
                    >
                      <img
                        src={`${appConfigs.APP_DOWNLOAD_LINK}static/console/${_item.icon}.png`}
                        alt={_item.name}
                        width="130"
                        height="130"
                      />
                    </span>
                  </div>
                ))}
              </div>
            ) : null}
          </>
        )}
      </CardLayout>

      {/* Start Create Modal */}
      <CustomModal
        title={`${id ? "ویرایش" : "افزودن"} دسته بندی`}
        show={isShowModal}
        onHide={handleCloseModal}
        size="lg"
      >
        <form
          onSubmit={id ? handleEditCategoryItem : handleCreateCategoryItem}
          autoComplete="off"
        >
          <div className="row">
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="name">نام</label>
              <input
                type="text"
                id="name"
                name="name"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="description">توضیحات</label>
              <textarea
                id="description"
                name="description"
                className="form-control"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="icon">آیکن</label>
              <input
                type="text"
                id="icon"
                name="icon"
                className="form-control"
                value={icon}
                onChange={(e) => setIcon(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="smallIcon">آیکن گرد</label>
              <input
                type="text"
                id="smallIcon"
                name="smallIcon"
                className="form-control"
                value={smallIcon}
                onChange={(e) => setSmallIcon(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="rank">جایگاه</label>
              <input
                type="number"
                id="rank"
                name="rank"
                className="form-control"
                value={rank}
                onChange={(e) => setRank(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label htmlFor="cities">شهر</label>
              <Select
                options={cities}
                value={added_cities}
                placeholder="شهر ها را انتخاب کنید"
                isMulti
                name="cities"
                onChange={setAdded_cities}
              />
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label>پیشنمایش آیکن</label>
              <div className="text-center">
                {icon && icon.length > 3 ? (
                  <img
                    src={`${appConfigs.APP_DOWNLOAD_LINK}/static/console/${icon}.png`}
                    alt={icon}
                    className="img-fluid img-thumbnail rounded"
                  />
                ) : (
                  <p className="alert alert-info m-0">آیکنی وارد نشده است</p>
                )}
              </div>
            </div>
            <div className="col-12 col-md-6 mb-2">
              <label>پیشنمایش آیکن گرد</label>
              <div className="text-center">
                {smallIcon && smallIcon.length > 3 ? (
                  <img
                    src={`${appConfigs.APP_DOWNLOAD_LINK}/static/console/${smallIcon}.png`}
                    alt={smallIcon}
                    className="img-fluid img-thumbnail rounded"
                  />
                ) : (
                  <p className="alert alert-info m-0">
                    آیکن گردی وارد نشده است
                  </p>
                )}
              </div>
            </div>
          </div>
          <button className="btn btn-primary" type="submit">
            <i className="fas fa-check mr-2" /> {id ? "ویرایش" : "افزودن"}
          </button>
          {/* <button
            onClick={() =>
              areYouSureMessage(
                () => handleDeleteCategoryItem(id),
                `آیا از حذف ${name} اطمینان دارید؟`
              )
            }
            className="btn btn-danger ml-2"
            type="button"
          >
            <i className="fas fa-trash mr-2" /> حذف
          </button> */}
        </form>
      </CustomModal>
      {/* End Create Modal */}

      {/* Start Details Modal */}
      <CustomModal
        title="جزئیات دسته بندی"
        show={isShowDetailsModal}
        onHide={handleCloseDetailsModal}
        size="xl"
      >
        <div className="container">
          <div className="row">
            <ItemInfo label="شناسه">
              <p>{category.id}</p>
            </ItemInfo>
            <ItemInfo label="نام">
              <p>{category.name}</p>
            </ItemInfo>
            <ItemInfo label="توضیحات">
              <p>{category.description}</p>
            </ItemInfo>
            <ItemInfo label="آیکن">
              <p>{category.icon}</p>
            </ItemInfo>
            <ItemInfo label="آیکن گرد">
              <p>{category.small_icon}</p>
            </ItemInfo>
            {category.city && (
              <ItemInfo label="استان ها">
                <p>
                  {category.city?.map((_item) => (
                    <span>{_item.name}, </span>
                  ))}
                </p>
              </ItemInfo>
            )}
            <ItemInfo label="پیشنمایش آیکن">
              <p className="text-center">
                <img
                  src={`${appConfigs.APP_DOWNLOAD_LINK}/static/console/${category.icon}.png`}
                  alt={category.icon}
                  className="img-fluid img-thumbnail rounded"
                />
              </p>
            </ItemInfo>
            <ItemInfo label="پیشنمایش آیکن گرد">
              <p className="text-center">
                <img
                  src={`${appConfigs.APP_DOWNLOAD_LINK}/static/console/${category.small_icon}.png`}
                  alt={category.small_icon}
                  className="img-fluid img-thumbnail rounded"
                />
              </p>
            </ItemInfo>
          </div>
        </div>
      </CustomModal>
      {/* End Details Modal */}
    </>
  );
};

export default CategoryAdmin;
